import { createStateContext } from 'react-use';

export const [useApplicationContext, ApplicationContextProvider] = createStateContext(null);
